import Vue from 'vue';
import Vuex from 'vuex';
import { IAppState } from './modules/app';
import { IUserState } from './modules/user';
import { QueryState } from './modules/query';

Vue.use(Vuex);

export interface IRootState {
  app: IAppState;
  user: IUserState;
  query: QueryState;
}

export default new Vuex.Store<IRootState>({});

